<script setup>
import BerufField from '@/components/fields/BerufField.vue'
import BrancheField from '@/components/fields/BrancheField.vue'
import PLZField from '@/components/fields/PLZField.vue'
import { useLohndatenStore } from '@/stores/lohndaten'
import { ref } from 'vue'

const store = useLohndatenStore()

const base_url = import.meta.env.VITE_API_HOST

const result = ref('')

async function onSubmit() {
  const fd = new FormData()
  fd.set('branche', store.branche)
  fd.set('job', store.beruf)
  fd.set('commune', store.onrp)

  const r = await fetch(base_url + '/lohnrechner/mappings/', {
    method: 'POST',
    body: fd
  }).then((response) => response.json())

  result.value = r.name || '-'
}
</script>

<template>
  <Vueform :endpoint="async (data, form) => onSubmit(data, form)">
    <BerufField></BerufField>
    <BrancheField></BrancheField>
    <PLZField></PLZField>
    <ButtonElement :submits="true" button-label="Submit" :full="true" size="lg"> </ButtonElement>
  </Vueform>
  <h2>
    {{ result }}
  </h2>
</template>
